import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import MetricTable from 'scoreboard/scorecards/metrics/metrics-table'
import noMetrics from 'scoreboard/scorecards/metrics/no-metrics.hbs'
import template from './annual-metric-data-results.hbs'
import LoadingDots from 'scoreboard/components/loading-dots'
import { streamLoaderPromise }  from 'scoreboard/components/export/stream-loader'
import ResultsView from '../common/results-view'
import invalidFilters from '../common/invalid-filters.hbs'
import EmptyState from 'scoreboard/components/empty-state'
import mobile from 'scoreboard/components/mobile'
import constants from 'scoreboard/components/constants'
import streamLoader from 'scoreboard/components/export/stream-loader'

var AnnualMetricDataResults = ResultsView.extend({

	className: 'scroll-layout-xy table-hack-row display-pane-body',

	initialize: function(options) {
		ResultsView.prototype.initialize.apply(this, arguments)

		this.parent = this.options.parent
		this.parent.deferredReady = true
		this.tableView = new MetricTable({
			el: this.el,
			tableSelector: '.annual-metric-data-results',
			section: constants.SECTION_REPORTS,
			preventTooltip: this.options.preventTooltip
		})
		this.on('resize', this.handleEmptyDisplay.bind(this))
	},

	render: function () {
		this.tableView.displayOptions(this.model.get('displayOptions'))
		this.tableView.initialData(this.model.initialData)

		this.$el.html(template(this.context()))
		this.tableView.scrollEl = this._getScrollContainer()

		let metadata = this.model.metadata
		if (metadata && metadata.invalid) {
			this.$el.html(new EmptyState({ body: invalidFilters() }).render().remove('header').el)
			// We already have a display header on this page, so no  need to
			this.$el.find('header').remove()
			// Make sure empty display styling kicks in
			$('.display-layout').addClass('has-empty-display')
		} else {
			//if results haven't been fetch, get them
			if (!this.model.results) {
				this._loading = true
				this.model.fetch().then(this._renderResults.bind(this))
			} else {
				this._renderResults()
			}

			var dots = this.$('.loading-dots-container')
			if (this._loading) {
				this.loadingView = new LoadingDots({el: dots}).render()
			} else {
				dots.remove()
			}
			if (this.parent) {
				streamLoader(this.parent, this.model.results)
			}
		}

		this._updateHeaderVisibility()
		this.renderMaxResultsBanner() // uses report metadata

		return this
	},

	_renderResults: function() {
		delete this._loading

		let streamEnded = this.model.results.done
		this.tableView.stream(this.model.results, {deferSetup: true})
		this.tableView.render()
		this.model.results.next()

		//handle scenario where the stream may have ended with no results before we've attached the
		//stream end listener
		if (streamEnded) {
			let data = this.model.initialData || []
			this.handleMetricResultCount(data.length)
		}
	},

	handleMetricResultCount: function(numMetrics) {
		this.renderMaxResultsBanner()
		const hasNoMetrics = numMetrics === 0
		this.$('.table-hack-cell, .scroll-container').toggleClass('is-not-displayed', hasNoMetrics)
		// This method may be called twice so prevent the empty state from being appended again.
		if (hasNoMetrics && _.isNil(this.hasNoMetrics)) {
			this.$el.append(noMetrics())
			this.handleEmptyDisplay()
			this.hasNoMetrics = true
		} else if (!hasNoMetrics) {
			this.$('.empty-state').remove()
			delete this.hasNoMetrics
		}
	},

	// In this view, it's possible to run into a situation where we can, at the same time,
	// have an empty state message and a footer with buttons. For non-mobile, things are
	// taken care of with .table-hack-row but in the mobile orientation, we need to
	// append .empty-display in order for the .empty-state styling to kick in correctly
	handleEmptyDisplay: function() {
		// Appending .empty-display to this.$el here does no good, it must go on .display-layout.
		$('.display-layout').toggleClass('empty-display', !_.isNil(this.hasNoMetrics) && mobile.isMobileWidth())
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.tableView, this.loadingView], 'remove')
	},

	exportTable: function(label) {
		return streamLoaderPromise(this, this.model.results).then(() => {
			return this.tableView.exportTable(label)
		})
	}

})

export default AnnualMetricDataResults
export { template }

AnnualMetricDataResults.__filename__ = 'reports/annual-metric-data/annual-metric-data-results.js'
